import { HTTP_STATUS } from '../response';

export interface RemoteSendCrossPlatformEmailRequest {
	emailAddress: string;
	acceptsEmailOptin: boolean;
}

export enum SendCrossPlatformEmailError {
	EmailConflict = 'EmailConflict',
	EmailInvalidFormat = 'EmailInvalidFormat',
	EmailBlacklisted = 'EmailBlacklisted'
}

export interface SendCrossPlatformEmailSuccessResponse {
	status: HTTP_STATUS;
}

export interface SendCrossPlatformEmailErrorResponse {
	status: HTTP_STATUS;
	error?: SendCrossPlatformEmailError;
}

export type SendCrossPlatformEmailResponse = SendCrossPlatformEmailSuccessResponse | SendCrossPlatformEmailErrorResponse;

export type SendCrossPlatformAction = (
	request: RemoteSendCrossPlatformEmailRequest,
	locale: string
) => Promise<SendCrossPlatformEmailResponse>;